<template>
  <div class="create-company">
    <Form ref="subForm" :model="subForm" :rules="subFormRules">
      <div class="left">
        <p class="decs">请完善企业信息</p>

        <FormItem label="企业名称" prop="companyName" :label-width="90">
          <Select
            v-model.trim="subForm.companyName"
            class="no-icon"
            style="width: 350px;text-align: left;"
            filterable
            remote
            placeholder="请输入和营业执照一致的企业全称"
            :remote-method="companySearch"
          >
            <Option
              v-for="option in companyList"
              :value="option.customerName"
              :key="option.customerName"
              >{{ option.customerName }}</Option
            >
          </Select>
          <p style="text-align: left;padding-left: 15px;color: #f00" v-if="showValidate">该企业已存在,请前往<span class="login" @click="previous('3')">【加入企业】</span></p>
        </FormItem>
        <FormItem
          label="企业性质"
          prop="nature"
          :label-width="90"
        >
          <Select
            v-model="subForm.nature"
            style="width: 350px;text-align: left;"
            placeholder="请选择您的企业性质"
          >
            <Option
              v-for="item in nature"
              :value="item.value"
              v-text="item.label"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="企业类型"
          prop="businessType"
          :label-width="90"
        >
          <Select
            v-model="subForm.businessType"
            style="width: 350px;text-align: left;"
            placeholder="请选择您的企业类型"
          >
            <Option
              v-for="item in businessType"
              :value="item.value"
              v-text="item.label"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="企业规模"
          prop="companyScaleType"
          :label-width="90"
        >
          <Select
            v-model="subForm.companyScaleType"
            style="width: 350px;text-align: left;"
            placeholder="请选择您的企业人员规模"
          >
            <Option
              v-for="item in companyScaleTypeList"
              :value="item.value"
              v-text="item.label"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          label="主管税务机关"
          prop="competentTaxAuthority"
          :label-width="90"
        >
          <Input
            type="text"
            v-model="subForm.competentTaxAuthority"
            placeholder="请输入主管税务机关"
            style="width: 350px"
          />
        </FormItem>
        <FormItem
          label="申请人角色"
          prop="characterPosition"
          :label-width="90"
        >
          <Select
            v-model="subForm.characterPosition"
            style="width: 350px;text-align: left;"
            placeholder="请选择申请人角色"
          >
            <Option
              v-for="item in characterPositionList"
              :value="item"
              v-text="item"
              :key="item"
              >{{ item }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          v-if="subForm.characterPosition == '其他'"
          label=""
          prop="characterPosition"
          :label-width="90"
        >
          <Input
            type="text"
            v-model="characterPositionElse"
            placeholder="请输入申请人角色"
            style="width: 350px"
          />
        </FormItem>
        <FormItem
          label="工作邮箱"
          :label-width="90"
          class="ivu-form-item-required"
          prop="mail"
        >
          <Input
            type="text"
            v-model="subForm.mail"
            placeholder="请输入申请人角色"
            style="width: 350px"
          />
        </FormItem>
        <p class="decs">企业实际所在地址</p>
        <FormItem
          label="办公地址"
          prop="companyAddress"
          :label-width="90"
        >
          <FormItem
            prop="city"
            label=""
            :label-width="0"
            style="display: inline-block"
          >
            <Cascader
              v-model="subForm.city"
              :data="cityData"
              filterable
              style="width: 350px;text-align: left;"
            ></Cascader>
          </FormItem>
          <Input
            type="text"
            v-model="subForm.companyAddress"
            placeholder="请输入完整具体到门牌号的地址"
            style="width: 350px"
          />
        </FormItem>
      </div>
      <div class="right">
        <p class="decs" style="margin-bottom: -2px">营业执照</p>
        <FormItem prop="uploadFile">
          <div
            class="upload-file-btn"
            :class="{ pointer: !imgurl }"
            style="position: relative; overflow: hidden; width: 100%;cursor: pointer;"
          >
            <template v-if="!imgurl">
              <Upload
                multiple
                ref="uploadImages"
                :show-upload-list="false"
                class="upload-file"
                :format="['jpg', 'jpeg', 'png', 'gif', 'rtf', 'pdf']"
                :on-format-error="handleFormatError"
                :max-size="10240"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleUpload"
                :on-success="uploadSuccess"
                name="uploadFile"
                action=""
              >
                <div class="upload-box">
                  <img src="../../images/zhizhao.png" class="zhizhao" />
                  <img src="../../images/add.png" class="add-icon" />
                  <p class="txt">点击上传您的营业执照</p>
                </div>
              </Upload>
            </template>
            <template v-if="imgurl">
              <iframe
                v-if="isPDF"
                :src="imgurl"
                style="
                  width: 100%;
                  height: 304px;
                  margin-top: 30px;
                "
              />
              <img v-else :src="imgurl" class="zhizhao" />
              <div class="sign" style="cursor: pointer" @click="clearImage">
                <Icon type="ios-trash-outline" size="18"></Icon>
              </div>
            </template>
          </div>
          <div class="ivu-form-item-error-tip" v-text="uploadErr"></div>
        </FormItem>
      </div>
      <FormItem style="margin: 0px">

        <Button
          type="text"
          class="next-btn"
          style="width: 200px;border-color:#fff"
          @click="previous('1')"
        >
          加入企业
        </Button>
        <Button
          type="primary"
          size="large"
          style="width: 200px"
          @click="valiSubmit('subForm')"
          :loading="loading"
        >
          立即创建
        </Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import city from "@/static/city";
import { companySearch, validateCompany, createCompany, characterPosition } from "@/api/home";
import Cookie from 'js-cookie';
import { encrypt, decode } from "@/libs/encrypt-and-decode.js"
import Compressor from 'compressorjs';
import { uploadFileAddWaterMark } from "@/api/file"
export default {
  props:{
    companyName:{
      type: String,
      default:''
    }
  },
  data() {
    const validateCompanyName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入企业名"));
      } else {
        if (this.timeOutValide) clearTimeout(this.timeOutValide);
        var timeOutValide = setTimeout(() => {
          validateCompany({
            keywords: value
          }).then(res => {
            if (res && res.data.code == "CUS-1028") {
              this.showValidate = true
            } else if (res.data.code == 0) {
              this.showValidate = false
              callback();
            } else {
              this.showValidate = false
              callback(new Error(res.data.msg));
            }
          })
        }, 200);
      }
    };
    const validateCompanyAddress = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入完整的企业实际所在地址（寄发票用）"));
      } else if (value.length < 5) {
        callback(new Error("请输入完整的企业实际所在地址（寄发票用）"));
      } else {
        callback();
      }
    };
    const validateCity = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error("请选择企业实际省市"));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (!value || !/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(value)) {
        callback(new Error('请输入正确的邮箱格式'))
      }else{
        callback()
      }
    };
    return {
      showValidate: false,
      subForm: {
        nature: null,
        companyName: "",
        companyAddress: "",
        companyScaleType: "",
        businessLicencePath: "",
        city: [],
        competentTaxAuthority: ""
      },
      subFormRules: {
        companyName: [
          {
            required: true,
            validator: validateCompanyName,
            trigger: "change",
          },
        ],
        companyAddress: [
          {
            required: true,
            message: "请输入完整的企业实际所在地址（寄发票用）",
            trigger: "blur",
          },
          {
            validator: validateCompanyAddress,
            trigger: "blur",
          },
        ],
        mail:{
          required: true,
          validator: validateEmail,
          trigger: 'blur'
        },
        // nature: {
        //   required: true,
        //   message: "请选择企业性质",
        //   trigger: "change",
        // },
        // businessType: {
        //   required: true,
        //   message: "请选择企业类型",
        //   trigger: "change",
        // },
        // companyScaleType: {
        //   required: true,
        //   message: "请选择企业规模",
        //   trigger: "change",
        // },
        city: {
          required: true,
          validator: validateCity,
          trigger: "change",
        },
        // characterPosition: {
        //   required: true,
        //   message: "请选择申请人角色",
        //   trigger: "change",
        // },
      },
      companyList: [],
      cityData: city,
      nature: [
        {
          label: "外企",
          value: "外企",
        },
        {
          label: "国企",
          value: "国企",
        },
        {
          label: "私企",
          value: "私企",
        },
        {
          label: "个体工商户",
          value: "个体工商户",
        },
        {
          label: "合资公司",
          value: "合资公司",
        },
      ],
      businessType: [
        {
          label: "运输代理",
          value: "运输代理",
        },
        {
          label: "贸易公司",
          value: "贸易公司",
        },
        {
          label: "报关行",
          value: "报关行",
        },
        {
          label: "船公司",
          value: "船公司",
        },
        {
          label: "运输公司",
          value: "运输公司",
        },
        {
          label: "生产公司",
          value: "生产公司",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      companyScaleTypeList: [
        {
          label: "1-5人",
          value: "LESS_THAN_FIVE",
        },
        {
          label: "6-10人",
          value: "SIX_TO_TEN",
        },
        {
          label: "11-20人",
          value: "ELEVEN_TO_TWENTY",
        },
        {
          label: "21-50人",
          value: "TWENTY_ONE_TO_FIFTY",
        },
        {
          label: "50人以上",
          value: "MORE_THAN_FIFTY",
        },
      ],
      imgurl: null,
      uploadErr: null,
      loading:false,
      characterPositionList: [],
      characterPositionElse: null,
      file: null
    };
  },
  mounted(){
    if(this.companyName){
      this.subForm.companyName = this.companyName
      this.companySearch(this.companyName)
    }
    this.getCharacterPosition()
  },
  watch:{
    'characterPosition'(val){
      if(val != '其他'){
        this.characterPositionElse = null
      }
    },
    "subForm.companyName":{
      handler: function (val){
        if(val){
          this.$emit('getCompany',val)
        }
      },
      deep:true
    },
    "file"(file){
      if(file){
       
        if(file.type == 'application/pdf'){
          this.postImg(file);
          return
        }
        new Compressor(file,{
          quality: 0.6,
          success: result => {
            console.log('=result=>', result)
            this.postImg(result);
          },
          error: err => {
            console.log('===err===', err)
          }
        })
      }
    }
  },
  methods: {
    // 职位list
    getCharacterPosition(){
      characterPosition().then(res => {
        console.log('getCharacterPosition',res)
        if(res && res.data.success){
          this.characterPositionList = res.data.data
        }
      })
    },
    // 获取企业list
    companySearch: _.debounce(function (value) {
      value &&
        companySearch({
          name: value,
        }).then((res) => {
          if (res && res.data.success) {
            this.companyList = res.data.objs;
          }
        });
    }, 900),
    // 上传图片
    handleUpload(file) {
      console.log(file)
      this.file = file;
      return false
    },
    // 提交图片到后端
    postImg(file) {
      let formData = new FormData();
      formData.append("uploadFile", file);
      uploadFileAddWaterMark(formData)
        .then(res => {
          console.log(res);
          if (res && res.data.success) {
            res = JSON.parse(res.data.data.value);
            this.isPDF = /.[pP][dD][fF]$/.test(res.businessLicenceUrl);
            this.subForm.businessLicencePath =
            res.businessLicenceUrlWaterRemark;
            this.imgurl = res.businessLicenceUrlWaterRemark;
            this.uploadLoading = false;
          } else {
            Toast("网络异常, 请重新上传");
          }
        })
        .catch(() => {
          this.files.status = "failed";
          this.files.message = "上传失败";
        });
    },
    handleFormatError(file, fileList) {
      this.uploadErr = "请上传图片格式或者PDF格式文件";
    },
    handleMaxSize(file) {
      this.uploadErr = "上传的文件大小不能大于10MB";
    },
    uploadSuccess(res, file) {
      if (res.success) {
        res = JSON.parse(res.data.value);
        this.isPDF = /.[pP][dD][fF]$/.test(res.businessLicenceUrl);
        this.subForm.businessLicencePath =
        res.businessLicenceUrlWaterRemark;
        this.imgurl = res.businessLicenceUrlWaterRemark;
        this.uploadLoading = false;
      }
    },
    clearImage() {
      this.imgurl = "";
      this.subForm.businessLicencePath = "";
    },
    valiSubmit(key) {
      this.$refs[key].validate((valid) => {
        if (valid) {
          
          if (!this.subForm.businessLicencePath) {
            this.uploadErr = "请上传营业执照";
            return;
          }
          if(this.subForm.characterPosition == '其他' && this.characterPositionElse == null ){
            this.$Message.error('请填写申请人角色');
            return;
          }
          this.loading = true
          let sendDataClone = _.cloneDeep(this.subForm);
          
          this.characterPositionElse ? sendDataClone.characterPosition = this.characterPositionElse : ''
          if (sendDataClone.city[0] == sendDataClone.city[1]) {
            sendDataClone.city = sendDataClone.city[0];
          } else {
            sendDataClone.city = sendDataClone.city.toString().replace(",", "");
          }
          sendDataClone.userId = decode(Cookie.get('user'))
          createCompany(sendDataClone).then( res => {
            this.loading = false
            if( res && res.data.success){
              this.$emit("createCompany",true)
            }else {
              this.$Message.error(res.data.msg);
            }
          })
        }
      });
    },
    previous(flag) {
      this.$emit("next", 1);
    },
  },
};
</script>

<style lang="less">
.create-company {
  width: 100%;
  .ivu-form-item-error-tip {
    margin-left: 20px;
  }
  .left {
    display: inline-block;
    width: 49%;
    height: 100%;
  }
  .right {
    display: inline-block;
    width: 50%;
    height: 100%;
    vertical-align: top;
    .zhizhao {
      // width: 90%;
      margin: 0 auto;
      margin-top: 35px;
      max-height: 304px;
    }
    .upload-box {
      position: relative;
      .add-icon {
        position: absolute;
        width: 30px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .txt {
        position: absolute;
        left: 50%;
        top: 63%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
  .ivu-btn-primary:hover {
		background: #ff9100;
    border-color: #ff9100;
	}
  .decs {
    color: #8c9093;
    font-size: 14px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// create-company.vue?5bcca0ac